// src/ConsumerApp/api/profile/profile.service.js
import { apiClient } from '../apiClient';

export const profileService = {
  getProfileDetails: async (customerId, token) => {
    const response = await apiClient.get(
      `/brickbucket/customer/get-customer-by-customerId?customer_id=${customerId}`,
      {
        headers: token ? { 'x-token': token } : {},
      }
    );
    return response.data || response;
  },

  updateProfileDetails: async (payload, token) => {
    const formData = new FormData();
    formData.append('_id', payload.id);
    formData.append('customer_name', payload.name);
    formData.append('mobile_number', payload.mobile);
    formData.append('email', payload.email);
    formData.append('customer_type', payload.selectedBuyerType);
    formData.append('company_name', payload.companyName || '');
    formData.append('type_of_firm', payload.typeOfFirm || '');
    formData.append('gstin', payload.gstin || '');
    formData.append('pan', payload.pan || '');
    formData.append('association', payload.association || '');

    if (payload.imageFile) {
      formData.append('file', payload.imageFile);
    }

    const response = await apiClient.put(
      '/brickbucket/customer/update-customer-from-profilepage',
      formData,
      {
        headers: {
          ...(token ? { 'x-token': token } : {}),
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data || response;
  },

  customerLogout: async (token) => {
    const response = await apiClient.post(
      '/brickbucket/customer/customer-logout',
      {},
      {
        headers: token ? { 'x-token': token } : {},
      }
    );
    return response.data || response;
  },

  deleteCustomerAccount: async (payload, token) => {
    const response = await apiClient.post(
      '/brickbucket/customer/delete-customer-account',
      {
        customer_id: payload.customer_id,
        feedback: payload.feedback,
      },
      {
        headers: token ? { 'x-token': token } : {},
      }
    );
    return response.data || response;
  },
};